import store from "../store/index"
import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"
import { os, cleanStatusAndTimerForLogout } from "./utils"
import { generateGUID } from "@/api/net/util"
// const baseURL: string = './'
const baseURL: string = window.config ? window.config.netUrl : ""

type errorResponse = { response: AxiosResponse }

let service: AxiosInstance = Axios.create({
  method: "POST",
  baseURL,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
    "source": "merchant-spa"
  },
  timeout: 50000,
})

export const showLoadingIgnoreUrlPrefixList: string[] = [
  "/api/Communicate/newMessages",
  "/api/Communicate/customer",
  "/api/Communicate/unread/count",
  "/api/Communicate/read",
  "/api/Order/merchorders",
  "/api/Communicate/conversations",
  "/api/Communicate/messages",
  "/api/Order/merchOrderCancellationRequests",
  "/api/Order/",
]
const notChangeTimestampRequests: string[] = [
  "/api/Communicate/conversations",
  "/api/Communicate/unread/count",
  "/api/get-qiniu-token",
  "/api/Communicate/messages",
  "/api/Communicate/read",
  "/api/Communicate/customer",
  "/api/User/rating"
]
// request拦截器
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (!store.state.showLoading && !isUrlInIgnoreList(config.url)) {
      store.commit("handleShowLoading", true)
    }
    config.headers["Authorization"] = `Bearer ${sessionStorage.getItem(
      "token"
    )}`
    config.headers[
      "timeZone"
    ] = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (!os().isPc) {
      config.headers["merchId"] = store.state.merchId
    }
    const requestMethod: string = config.method as string
    const isNotChangeTimestampRequests: boolean = notChangeTimestampRequests.includes(config.url as string)
    if (requestMethod.toLowerCase() === "post" && !isNotChangeTimestampRequests) {
      store.commit("handleRequestTimeStamp", new Date().getTime())
    }
    if (requestMethod.toLowerCase() === "get") {
      const timeStamp: number = store.state.requestTimeStamp
      config.url = `${config.url}?ts=${timeStamp}`
    }
    return config
  },
  (error: errorResponse) => {
    store.commit("handleShowLoading", false)
    window.Vue.$message.show({
      text: "Network error",
    })
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  (response: any) => {
    // store.commit("handleShowLoading", false);
    return response
  },
  (error: errorResponse) => {
    store.commit("handleShowLoading", false)
    if (error.response && error.response.status === 401) {
      cleanStatusAndTimerForLogout()
    }
    if (
      error.response &&
      error.response.data &&
      error.response.data.ErrorText
    ) {
      window.Vue.$message.show({
        text: error.response.data.ErrorText,
      })
    }
    try {
      logError(error)
    } finally {
      return Promise.reject(error)
    }
  }
)

const isUrlInIgnoreList = (url: string | undefined) => {
  return url && showLoadingIgnoreUrlPrefixList.some((x) => url.startsWith(x))
}

export const logError = (errorData: any) => {
  Axios.request({
    headers: {
      "X-Seq-ApiKey": "UrEWi6ll8xlyE0piIMq9",
    },
    method: "POST",
    url: "https://seq-dev.yamimeal.com/api/events/raw?clef",
    data: {
      "@t": new Date().toISOString(),
      "@l": "Error",
      Application: "OXYGEN-MANAGEMENT",
      "@mt": `oxygen-management error request`,
      CorrelationId: generateGUID(),
      requestData: errorData.config,
    },
  })
}

export default service
